module.exports = __webpack_public_path__ + "img/2015pigc.c3107f86.png";